// extracted by mini-css-extract-plugin
export default {"container":"openHours_container__tJYbO","openHours":"openHours_openHours__p7a7H","inline":"openHours_inline__Z7C56"};